(function () {
  class AtlasTilesWithModal {
    constructor(root) {
      this.root = root;
      this.dialog = root.querySelector('[data-atm-dialog]');
      this.overlay = root.querySelector('[data-atm-overlay]');
      this.closeBtns = root.querySelectorAll('[data-atm-close]');
      this.tiles = root.querySelectorAll('[data-atm-open]');
      this.headerMedia = root.querySelector('[data-atm-modal-media]');
      this.modalTitle = root.querySelector('[data-atm-modal-title]');
      this.modalCopy = root.querySelector('[data-atm-modal-copy]');
      this.activeTrigger = null;
      this.boundKeydown = this.onKeydown.bind(this);

      if (!this.dialog) return;

      this.bindUI();
    }

    bindUI() {
      this.tiles.forEach(
        function (tile) {
          tile.addEventListener(
            'click',
            function () {
              this.open(tile);
            }.bind(this)
          );
        }.bind(this)
      );

      this.closeBtns.forEach(
        function (btn) {
          btn.addEventListener(
            'click',
            function () {
              this.close();
            }.bind(this)
          );
        }.bind(this)
      );

      if (this.overlay) {
        this.overlay.addEventListener(
          'click',
          function () {
            this.close();
          }.bind(this)
        );
      }

      if (typeof HTMLDialogElement !== 'undefined' && this.dialog instanceof HTMLDialogElement) {
        this.dialog.addEventListener(
          'cancel',
          function (event) {
            event.preventDefault();
            this.close();
          }.bind(this)
        );
      }
    }

    open(tile) {
      if (!this.dialog || !tile) return;

      this.activeTrigger = tile;

      const title = tile.dataset.atmTitle || '';
      const copyId = tile.dataset.atmCopyId || '';
      const imageUrl = tile.dataset.atmModalImage || '';
      const imageAlt = tile.dataset.atmModalImageAlt || title;
      const copyTemplate = copyId ? document.getElementById(copyId) : null;

      if (this.modalTitle) {
        this.modalTitle.textContent = title;
      }

      if (this.modalCopy) {
        this.modalCopy.innerHTML = '';
        if (copyTemplate) {
          this.modalCopy.appendChild(copyTemplate.content.cloneNode(true));
        }
      }

      if (this.headerMedia) {
        this.headerMedia.innerHTML = '';
        this.headerMedia.classList.toggle('is-empty', !imageUrl);

        if (imageUrl) {
          const img = document.createElement('img');
          img.src = imageUrl;
          img.alt = imageAlt;
          img.width = 160;
          img.height = 160;
          img.decoding = 'async';
          this.headerMedia.appendChild(img);
        }
      }

      if (this.dialog.parentElement !== document.body) {
        document.body.appendChild(this.dialog);
      }

      this.dialog.classList.add('is-open');
      this.dialog.setAttribute('aria-hidden', 'false');

      if (typeof this.dialog.showModal === 'function' && !this.dialog.open) {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }

      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.boundKeydown);

      const closeBtn = this.dialog.querySelector('[data-atm-close]');
      if (closeBtn) closeBtn.focus();
    }

    close() {
      if (!this.dialog) return;

      this.dialog.classList.remove('is-open');
      this.dialog.setAttribute('aria-hidden', 'true');

      if (typeof this.dialog.close === 'function' && this.dialog.open) {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
      }

      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.boundKeydown);

      if (this.activeTrigger) {
        this.activeTrigger.focus();
        this.activeTrigger = null;
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-atlas-tiles-modal]').forEach(function (root) {
      if (root.dataset.atmInit === 'true') return;
      root.dataset.atmInit = 'true';
      new AtlasTilesWithModal(root);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (event) {
    const sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    const orphanDialog = document.getElementById('AtlasTilesModal--' + sectionId);
    if (orphanDialog) orphanDialog.remove();
  });
})();
